import script from "./CurrentInstruction.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentInstruction.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentInstruction.vue?vue&type=style&index=0&id=3edde602&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3edde602"]])

export default __exports__